import {
    Component,
    OnInit,
    Inject,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ChangeDetectorRef,
    OnDestroy,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacySnackBarRef as MatSnackBarRef, LegacySimpleSnackBar as SimpleSnackBar, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Subscription } from 'rxjs';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { GetPermissionsResponseCustomer } from 'app/shared/models/users-permission';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { StringUtils } from 'app/shared/utils/string-utils';
import { UiUtilsService } from 'app/shared/utils/ui-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { EmailService } from 'app/shared/services/email.service';
import { CustomerService } from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { customerQueryParam } from 'app/shared/models/customer';
import { AssistanceCenter } from 'app/shared/models/assistance-center';
import { ApplicationSurvey, EmailContents } from 'app/shared/models/email-contents';
import { APIDefectReportEmailRequest, APISendCallEmailRequest, APISurveyEmailRequest, Attachment } from 'app/shared/models/email';
import { map, startWith } from 'rxjs/operators';
import { UsersService } from 'app/pages/admin/users.service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';

@Component({
    selector: 'app-assistance-center',
    templateUrl: './assistance-center.component.html',
    styleUrls: ['./assistance-center.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AssistanceCenterComponent implements OnInit, OnDestroy {
    public selectedTab: string;
    public selectedTabTitel: string;
    public emailContent: {
        customerName: string;
        phoneNumber;
        reasonForCall: string;
        userName: string;
        emailPrimary: string;
        emailSecondary: string;
    };
    public emailContents = new EmailContents();
    private subscriptions = new Array<Subscription>();
    public reportImage: string | ArrayBuffer | null = null;

    /**
     * applicationSurvey will use to bind values on UI.
     */

    public applicationSurvey = new ApplicationSurvey();

    /**
     * Valid file extensions
     */
    private validFileExtensions = new Array<string>();

    /**
     * validExtensions to keep file extension.
     */
    public validExtensions: boolean;
    /**
     * Reg Ex. Pattern for alpha numeric
     */
    public alphaNumericPattern = REGEX_CONFIG.alphaNumericPattern;

    /**
     * Reg Ex. Pattern for alpha numeric with spaces and - and _
     */
    public alphaNumericWith_Pattern = REGEX_CONFIG.alphaNumericWith_Pattern;
    /**
     * Reg Ex. Pattern for space arround
     */
    public noSpaceArround = REGEX_CONFIG.noSpaceArround;

    /**
     * Reg Ex Pattern for email
     */
    public emailPattern = REGEX_CONFIG.strictEmailPattern;

    public numericOnlyPattern = REGEX_CONFIG.numericOnlyPattern;
    /**
     * Reg Ex Pattern for is Empty
     */
    public isEmptyPattern = REGEX_CONFIG.isEmpty;

    /**
     * Attachment file-Name.
     */
    private fileName: string;

    /**
     * loader flag @reportDefectLoadingState
     */
    public reportDefectLoadingState: boolean;
    public isRequestDone: boolean;

    /**
     * loader flag @appSurveyReportState
     */
    public appSurveyReportState: boolean;

    /**
     * File-size limit 20 MB.
     */
    public maxFileSize = 20 * 1024 * 1024;
    public exceedFileSize: boolean;

    /**
     * flag to check if customer name or reason for call is empty (contains only spaces)
     */
    public isEmpty = false;

    /**
     * flag to check if customer name is valid
     */
    public validCustomerName = false;

    /**
     * flag to check if customer name is invalid
     */
    public invalidCustomerName: boolean;
    /**
     * @surveyRating will use to show message at UI.
     */

    public surveyRating: boolean;

    /**
     * @howUseFulAppRating will use to show message at UI.
     */
    public howUseFulAppRating: boolean;

    /**
     * @featureMakeAppEasyRating will use to show message at UI.
     */
    public featureMakeAppEasyRating: boolean;

    /**
     * @navigationSatisficationRating will use to show message at UI.
     */
    public navigationSatisficationRating: boolean;

    private customerID: number;
    public filteredassignedCustomers: Observable<Array<GetPermissionsResponseCustomer>>;
    public customers = new Array<GetPermissionsResponseCustomer>();
    public assignedCustomerCtrl = new FormControl();

    public callSentSuccessMsg: string;
    public defectReportSuccess: string;
    public surveyReportSuccess: string;
    public reportRequestFailed: string;
    public dismissText: string;

    public SearchCountryField = SearchCountryField;
    public CountryISO = CountryISO;
    public preferredCountries: CountryISO[] = [
      CountryISO.UnitedStates,
      CountryISO.UnitedKingdom
    ];

    public trackByCustomerId = (index: number, item: GetPermissionsResponseCustomer) => { return item?.customer?.customerID; };

    constructor(
        private emailService: EmailService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<AssistanceCenterComponent>,
        @Inject(MAT_DIALOG_DATA) private data: AssistanceCenter,
        private cdr: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private customerService: CustomerService,
        private uiUtilsService: UiUtilsService,
        private translate: TranslateService,
        private authService: AuthService,
        private usersService: UsersService
    ) {}

    public ngOnInit() {
        this.translate.get('CUSTOMER_SUPPORT.CALL_REQUEST_SENT_SUCCESS').subscribe((res: string) => {
            this.callSentSuccessMsg = res;
        });
        this.translate.get('CUSTOMER_SUPPORT.DEFECT_REPORT_SENT_SUCCESS').subscribe((res: string) => {
            this.defectReportSuccess = res;
        });
        this.translate.get('CUSTOMER_SUPPORT.SURVEY_REPORT_SENT_SUCCESS').subscribe((res: string) => {
            this.surveyReportSuccess = res;
        });
        this.translate.get('COMMON.DISMISS_TEXT').subscribe((res: string) => {
            this.dismissText = res;
        });
        this.translate.get('CUSTOMER_SUPPORT.REPORT_REQUEST_FAILED').subscribe((res: string) => {
            this.reportRequestFailed = res;
        });

        // make the default selection No at survey form
        this.applicationSurvey.featureMakeAppEasy = 'No';

        this.validFileExtensions = ['JPEG', 'JPG', 'GIF', 'PNG', 'PDF'];
        this.validExtensions = true;
        this.exceedFileSize = true;
        this.selectedTab = this.data.selectedTab;
        this.selectedTabTitel = this.data.selectedTabName;
        this.emailContent = { customerName: '', phoneNumber: '', reasonForCall: '', userName: '', emailPrimary: '', emailSecondary: '' };
        this.emailContents.emailAddress = this.user.email;

        // subscribe to route params to get customerID
        this.activatedRoute.queryParamMap.subscribe(
            ((params: ParamMap) => {
                this.customerID = Number(params.get(customerQueryParam))
            }),
        );

        // If selecting Customer Support, get the list of all assigned customers.
        if (this.selectedTab === '0') {
            this.getAssignedUsers();
        }

        this.translate.get(`TOP_NAV.${this.selectedTabTitel.replace(/ /g, '_')}`).subscribe((res: string) => {
            this.selectedTabTitel = res;
        });

        this.usersService.userInfo$.subscribe(userInfo => {
            this.emailContent.userName = (userInfo.firstName || '') + ' ' + (userInfo.lastName || '');
            this.emailContent.phoneNumber = userInfo.phoneNumber || '';
            this.emailContent.emailPrimary = userInfo.userEmail || '';
            this.emailContent.emailSecondary = userInfo.secondaryEmail || '';
            this.emailContents.emailAddress = this.emailContent.emailPrimary;
        });
    }

    /**
     * Gets the user object
     */
    private get user() {
        return this.authService.user;
    }

    private getAssignedUsers() {
        this.customers = new Array<GetPermissionsResponseCustomer>();

        // get list of assigned customers.
        this.subscriptions.push(
            this.customerService.userCustomersWithLocations.subscribe((customers) => {
                if (customers && customers.length > 0) {
                    customers.forEach((customer) => {
                        this.customers.push(customer);
                        if(customer.customer && customer.customer.customerID === this.customerID) {
                            this.emailContent.customerName = customer.customer.customerName;
                            this.checkCustomerNameValidation();
                        }
                    });
                }

                // filter assigned customers on selection
                this.filteredassignedCustomers = this.assignedCustomerCtrl.valueChanges.pipe(startWith(null)).pipe(
                    map((customerName) => {
                        return customerName ? this.filterCustomers(customerName) : this.customers.slice();
                    }),
                );
            }),
        );
    }

    /**
     * Filter the customerName based on selection.
     * @param customerName
     */
    private filterCustomers(customerName: string) {
        return this.customers.filter(
            (customer) => customer.customer.customerName.toLowerCase().indexOf(customerName.toLowerCase()) === 0,
        );
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public emitAssistanceCenter() {
        this.dialogRef.close({ success: false });
    }

    public onChange(event: Event, input: HTMLInputElement) {
        const target = event.target as HTMLInputElement;
        const files = Array.from(target.files || []);
        input.value = files.map((f) => f.name).join(', ');
    }

    public trimCustomerName() {
        this.emailContent.customerName = this.emailContent.customerName.trim();
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Envoked when a selection event occurs on the customer AutoComplete.
     * @param event An instance of MatAutocompleteSelectedEvent.
     */
    public customerSelectedHandler(event: MatAutocompleteSelectedEvent) {
        this.validCustomerName = true;
        this.invalidCustomerName = false;
    }

    /**
     * Checks the customer name exist in customer list
     * @param selectedCustomerName - selected customer name
     */
    public checkValidCustomer(selectedCustomerName: string) {
        return this.customers.find((x) => x.customer.customerName === selectedCustomerName) ? true : false;
    }

    public sendCallRequest() {
        // checks if  customerName is valid
        if (!this.checkValidCustomer(this.emailContent.customerName)) {
            this.validCustomerName = false;
            this.invalidCustomerName = true;
            return;
        }

        this.isEmpty = false;

        const params: APISendCallEmailRequest = {
            CustomerName: this.emailContent.customerName,
            CustomerPhoneNumber: this.emailContent.phoneNumber?.number || '',
            CustomerPrimaryEmail: this.emailContent.emailPrimary,
            CustomerSecondaryEmail: this.emailContent.emailSecondary || '',
            ReasonForCall: this.emailContent.reasonForCall,
            UserName: this.emailContent.userName
        }

        this.isRequestDone = true;

        this.subscriptions.push(this.emailService.sendCallRequest(params).subscribe({
            next: (response) => {
                this.isRequestDone = false;
                if (response) {
                    const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(
                        this.callSentSuccessMsg,
                        this.dismissText,
                    );

                    setTimeout(() => {
                        snackbarRef.dismiss.bind(snackbarRef),
                            setTimeout(() => {
                                this.emitAssistanceCenter();
                            }, 2000);
                    }, 10000);
                }
            },
            error: (error) => {
                this.isRequestDone = false;
                const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(this.reportRequestFailed, this.dismissText, {
                    panelClass: 'custom-error-snack-bar',
                });
                this.emitAssistanceCenter();
                this.uiUtilsService.safeChangeDetection(this.cdr);
                setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
            }
        }));
    }

    /**
     * check  customer name Validation
     */
    public checkCustomerNameValidation() {
        // check if customer name is valid

        this.validCustomerName = this.checkValidCustomer(this.emailContent.customerName);
        this.invalidCustomerName = !this.validCustomerName;
    }

    /**
     * check  Phone Number Validation
     */
    public checkPhoneNumberValidation() {
        this.emailContent.phoneNumber = StringUtils.removeExtraSpace(this.emailContent.phoneNumber);
    }

    /**
     * This function capitalized the string value with maximum one space in between word
     */
    public capitalizedStringWithSpace() {
        this.emailContents.fullName = StringUtils.capitalizedStringWithSpace(this.emailContents.fullName);
    }

    /**
     * This function capitalized the string value with maximum one space in between word
     */
    public stepsToReproduceValidation() {
        this.emailContents.stepsToReproduce = StringUtils.capitalizedStringWithSpace(
            this.emailContents.stepsToReproduce,
        );
    }

    /*
     * Below function is used to send email for any defect report.
     */
    public async sendDefectReport() {
        // if stepsToReproduce only contained whitespace (ie. spaces, tabs or line breaks)
        this.isEmpty = StringUtils.isStringEmpty(this.emailContents.stepsToReproduce);

        if (this.isEmpty) {
            return;
        }
        this.isEmpty = false;

        // creating attachment contents
        const attachment: Attachment = {
            attachmentName: this.fileName,
            attachment: this.emailContents.reportImage,
        };

        this.emailContents.fullName.trim();

        const params: APIDefectReportEmailRequest = {
            FromUserEmailAddress: this.emailContents.emailAddress,
            FullName: this.emailContents.fullName,
            StepsToReproduce: this.emailContents.stepsToReproduce,
            ContactNumber: this.emailContents.contactNumber
        }

        this.reportDefectLoadingState = true;

        this.subscriptions.push(this.emailService.sendDefectReport(params, attachment).subscribe({
            next: (response) => {

                this.reportDefectLoadingState = false;
                if (response) {
                    const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(
                        this.defectReportSuccess,
                        this.dismissText,
                    );
                    this.emitAssistanceCenter();
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
                }
            },
            error: () => {
                this.reportDefectLoadingState = false;
                const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(this.reportRequestFailed, this.dismissText, {
                    panelClass: 'custom-error-snack-bar',
                });
                this.emitAssistanceCenter();
                this.uiUtilsService.safeChangeDetection(this.cdr);
                setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
            }
        }));
    }

    /*
     * Below function is used read the image content.
     */
    public loadImage(event: Event, input: HTMLInputElement) {
        const fileReader = new FileReader();
        const target = event.target as HTMLInputElement;
        const targetFiles = target.files;

        const files = Array.from(targetFiles || []);
        this.fileName = input.value = files.map((f) => f.name).join(', ');

        // Get the file extension from uploaded file.
        const uploadedFileExtension = this.fileName.toUpperCase().split('.').pop() || this.fileName;
        // validate if extension exists
        this.validExtensions = this.validFileExtensions.find((x) => x === uploadedFileExtension) ? true : false;

        // validate file file size w.r.t requirement 20 MB.
        if (targetFiles && targetFiles[0] && targetFiles[0].size > this.maxFileSize) {
            this.exceedFileSize = false;
        } else {
            this.exceedFileSize = true;
        }

        // validate file extension as well as size to upload
        if (this.validExtensions && this.exceedFileSize) {
            fileReader.addEventListener(
                'load',
                () => {
                    this.emailContents.reportImage = fileReader.result?.toString();
                },
                false,
            );
            // use below readAsDataURL for all file type.
            if (targetFiles && targetFiles[0]) {
                fileReader.readAsDataURL(targetFiles[0]);
            }
        } else {
            input.value = '';
        }
    } // end of function.

    /**
     * validate the how useful app
     */
    public checkHowUseFulAppRating(event: MatRadioChange) {
        // validate the how useful app survey form rating selection.
        this.howUseFulAppRating = event.value.length > 0 ? false : true;

        // validate the survey form rating selection.
        this.surveyRating =
            this.navigationSatisficationRating || this.featureMakeAppEasyRating || this.navigationSatisficationRating
                ? true
                : false;
    }

    /**
     * validate the satisfication level
     */
    public checkFeatureMakeAppEasyRating(event: MatRadioChange) {
        // validate the satisfication level survey form rating selection.
        this.featureMakeAppEasyRating = event.value.length > 0 ? false : true;

        // validate the survey form rating selection.
        this.surveyRating =
            this.navigationSatisficationRating || this.featureMakeAppEasyRating || this.navigationSatisficationRating
                ? true
                : false;
    }

    /**
     * validate the navigation satisfication
     */
    public checkNavigationSatisfication(event: MatRadioChange) {
        // validate the navigation satisfication survey form rating selection.
        this.navigationSatisficationRating = event.value.length > 0 ? false : true;

        // validate the survey form rating selection.
        this.surveyRating =
            this.navigationSatisficationRating || this.featureMakeAppEasyRating || this.navigationSatisficationRating
                ? true
                : false;
    }

    /**
     * validate the Survey Rating
     */
    private checkSurveyRating() {
        // validate the how useful app survey form rating selection.
        this.howUseFulAppRating = this.applicationSurvey.howUseFulApp === '' ? true : false;

        // validate the satisfication level survey form rating selection.
        this.featureMakeAppEasyRating = this.applicationSurvey.satisficationLevel === '' ? true : false;

        // validate the navigation satisfication survey form rating selection.
        this.navigationSatisficationRating = this.applicationSurvey.navigationSatisfication === '' ? true : false;

        this.surveyRating =
            this.navigationSatisficationRating || this.featureMakeAppEasyRating || this.navigationSatisficationRating
                ? false
                : true;
    }

    /**
     * Function sendAppSurveyReport will use to send application survey email.
     */
    public sendAppSurveyReport() {
        // validate the survey form rating selection.
        this.checkSurveyRating();

        if (!this.surveyRating) {
            this.surveyRating = true;
            return;
        }

        const params: APISurveyEmailRequest = {
            DepartmentalRole: this.applicationSurvey.departmentalRole,
            FeatureDescMakeAppEasy: this.applicationSurvey.featureDescMakeAppEasy,
            FeatureMakeAppEasy: this.applicationSurvey.featureMakeAppEasy,
            FinalComments: this.applicationSurvey.finalComments,
            HowUseFulApp: this.applicationSurvey.howUseFulApp,
            NavigationSatisfaction: this.applicationSurvey.navigationSatisfication,
            NavigationSatisfactionWhy: this.applicationSurvey.navigationSatisficationWhy,
            SatisfactionLevel: this.applicationSurvey.satisficationLevel,
            SatisfactionLevelWhy: this.applicationSurvey.satisficationLevelWhy
        }

        this.appSurveyReportState = true;

        this.subscriptions.push(this.emailService.sendSurveyEmail(params).subscribe({
            next: (response) => {
                this.appSurveyReportState = false;
                if (response) {
                    const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(
                        this.surveyReportSuccess,
                        this.dismissText,
                    );
                    this.emitAssistanceCenter();
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
                }
            },
            error: (error) => {
                this.appSurveyReportState = false;
                const snackbarRef: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(this.reportRequestFailed, this.dismissText, {
                    panelClass: 'custom-error-snack-bar',
                });
                this.emitAssistanceCenter();
                this.uiUtilsService.safeChangeDetection(this.cdr);
                setTimeout(snackbarRef.dismiss.bind(snackbarRef), 10000);
            },
        }));
    }
}
